<template>
  <QuillyEditor
    ref="editor"
    v-model="model"
    :options="options"
    class="rounded-b-lg border border-slate-950/10 focus:outline-none focus:ring-0 focus:shadow-none hover:border-slate-950/20 placeholder:text-slate-500 max-h-80 overflow-y-auto"
    v-bind="$attrs"
  />
</template>

<script lang="ts" setup>
import Quill from 'quill' // Full build
import { QuillyEditor } from 'vue-quilly'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { onMounted } from 'vue'
import { ref } from 'vue'

const model = defineModel<string>()

const props = defineProps({
  additionalOptions: {
    type: Object,
    default: () => ({})
  }
})

const options = {
  theme: 'snow',
  modules: {
    toolbar: true,
  },
  placeholder: 'Compose an epic...',
  readOnly: false,
  ...props.additionalOptions
}

const editor = ref<InstanceType<typeof QuillyEditor>>()

onMounted(() => {
  editor.value?.initialize(Quill)!
})

</script>

<style lang="scss" scoped>
.ql-toolbar.ql-snow {
  @apply rounded-t-lg border-b border-slate-950/10 focus:outline-none focus:ring-0 focus:shadow-none hover:border-slate-950/20;
}
.ql-editor {
@apply min-h-44 sm:min-h-56;
}
</style>
